import React from 'react';

export interface IEventSchedule {
    imageSVG: JSX.Element;
    text: string;
    baseClassName: string;
    date?: string;
    time?: string;
}

export const EventSchedule = (eventSchedule: IEventSchedule): JSX.Element => {
    const { baseClassName, text, date, time, imageSVG } = eventSchedule;
    return (
        <>
            <div className={`${baseClassName}__event-schedule`}>
                {imageSVG}
                <p>{text}</p>
                <p>{date || time}</p>
            </div>
        </>
    );
};